import btn_background_img from "../../images/btn_background.png";
import styles from "./styles.module.css";

const Button2 = ({name, onClick}) => {
 

  

  return (
    <button className={styles.btn} onClick={onClick}>
      <img
        src={btn_background_img}
        alt="btn_background_img"
        className={styles.btn_background_img}
      />
      {name}
    </button>
  );
};

export default Button2;
